module.exports = __webpack_public_path__ + "static/media/tailwind.3323dd02.svg";